import { useEffect } from "react";
import { useDispatch, useSelector } from "src/redux";

export default function withFilterOptions(WrappedComponent, getOptions) {
  return function (props) {
    const dispatch = useDispatch();
    const options = useSelector((state) => state.filter[props.by]);

    useEffect(() => {
      if (options.length === 0) {
        dispatch(getOptions(props.by));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <WrappedComponent options={options} {...props} />;
  };
}
